import { Injectable } from '@angular/core';
import { AmplifyService } from 'aws-amplify-angular';

@Injectable({
  providedIn: 'root',
})

export default class ManageImage {
  constructor(
    private amplifyService: AmplifyService,
  ) {}

  uploadProtectedImage(payloadData) {
    return this.amplifyService.storage().put(
      payloadData.keyName,
      payloadData.file,
      {
        level: 'protected',
        contentType: 'image/*',
      },
    );
  }

  uploadProtectedImages(payloadData) {
    const promises = [];
    payloadData.forEach((value) => {
      const promise = this.amplifyService.storage().put(
        value.keyName,
        value.file,
        {
          level: 'protected',
          contentType: 'image/*',
        },
      );
      promises.push(promise);
    });
    return Promise.all(promises);
  }

  getProtectedImage(imageKey, identityId: string) {
    return this.amplifyService.storage().get(imageKey, {
      level: 'protected',
      identityId,
      contentType: 'image/*',
    });
  }

  getPublicImage(imageKey, identityId?: string) {
    return this.amplifyService.storage().get(imageKey, {
      level: 'public',
      identityId,
      contentType: 'image/*',
    });
  }

  getProtectedImages(imageKeys, identityId: string) {
    const promises = [];
    imageKeys.forEach((value) => {
      const promise = this.amplifyService.storage()
        .get(value, {
          level: 'protected',
          identityId,
          contentType: 'image/*',
        });
      promises.push(promise);
    });
    return Promise.all(promises);
  }

  deleteProtectedImage(imageKey): any {
    if (imageKey !== '') {
      return this.amplifyService.storage().remove(imageKey, {
        level: 'protected',
      });
    }
  }

  deleteProtectedImages(imageKeys) {
    const promises = [];
    imageKeys.forEach((value) => {
      if (value !== '') {
        const promise = this.amplifyService.storage().remove(value, {
          level: 'protected',
        });
        promises.push(promise);
      }
    });
    return Promise.all(promises);
  }

  uploadProtectedVideo(payloadData): Promise<any> {
    return this.amplifyService.storage().put(
      payloadData.keyName,
      payloadData.file,
      {
        level: 'protected',
        contentType: 'video/*',
      },
    );
  }

  uploadProtectedVideoFiles(payloadData): Promise<any> {
    const promises = [];
    payloadData.forEach((value) => {
      const promise = this.amplifyService.storage().put(
        value.keyName,
        value.file,
        {
          level: 'protected',
          contentType: 'video/*',
        },
      );
      promises.push(promise);
    });
    return Promise.all(promises);
  }

  getProtectedVideo(videoKey, identityId: string) {
    return this.amplifyService.storage().get(videoKey, {
      level: 'protected',
      identityId,
      contentType: 'video/*',
    });
  }

  getProtectedVideoFiles(videoKeys, identityId: string) {
    const promises = [];
    videoKeys.forEach((value) => {
      const promise = this.amplifyService.storage()
        .get(value, {
          level: 'protected',
          identityId,
          contentType: 'video/*',
        });
      promises.push(promise);
    });
    return Promise.all(promises);
  }

  deleteProtectedVideo(videoKey): any {
    if (videoKey !== '') {
      return this.amplifyService.storage().remove(videoKey, {
        level: 'protected',
      });
    }
  }

  deleteProtectedVideoFiles(videoKeys): any {
    const promises = [];
    videoKeys.forEach((value) => {
      if (value !== '') {
        const promise = this.amplifyService.storage().remove(value, {
          level: 'protected',
        });
        promises.push(promise);
      }
    });
    return Promise.all(promises);
  }

  uploadProtectedPdf(payloadData): Promise<any> {
    return this.amplifyService.storage().put(
      payloadData.keyName,
      payloadData.file,
      {
        level: 'protected',
        contentType: 'application/pdf',
      },
    );
  }

  uploadProtectedPdfFiles(payloadData): Promise<any> {
    const promises = [];
    payloadData.forEach((value) => {
      const promise = this.amplifyService.storage().put(
        value.keyName,
        value.file,
        {
          level: 'protected',
          contentType: 'application/pdf',
        },
      );
      promises.push(promise);
    });
    return Promise.all(promises);
  }

  getProtectedPdf(pdfKey, identityId: string) {
    return this.amplifyService.storage().get(pdfKey, {
      level: 'protected',
      identityId,
      contentType: 'application/pdf',
    });
  }

  getProtectedPdfFiles(pdfKeys, identityId: string) {
    const promises = [];
    pdfKeys.forEach((value) => {
      const promise = this.amplifyService.storage()
        .get(value, {
          level: 'protected',
          identityId,
          contentType: 'application/pdf',
        });
      promises.push(promise);
    });
    return Promise.all(promises);
  }

  deleteProtectedPdf(pdfKey): any {
    if (pdfKey !== '') {
      return this.amplifyService.storage().remove(pdfKey, {
        level: 'protected',
      });
    }
  }

  deleteProtectedPdfFiles(pdfKeys): any {
    const promises = [];
    pdfKeys.forEach((value) => {
      if (value !== '') {
        const promise = this.amplifyService.storage().remove(value, {
          level: 'protected',
        });
        promises.push(promise);
      }
    });
    return Promise.all(promises);
  }
}
